import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = ["fill", "fill-opacity"]

import { PropType } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GuestIcon',
  props: {
    fill: {
      type: String,
    },
    fillOpacity: {
      type: String as PropType<'1' | '0.54'>,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2)
  ]))
}
}

})